export const showSnackbar = (snackbar: Snackbar) => {
  const { add } = useSnackbar();
  add(snackbar);
};
